export enum UserRoles {
    SUPERVISOR = "SUPERVISOR", // can't add channels
    AGENT = "AGENT",
    SUPERADMIN = "SUPER_ADMIN",
    COMPANY_ADMIN = "COMPANY_ADMIN",
}
